<template>
  <div class="page-scroll-container" ref="pageContainer">
    <!-- 1. [底层] 清晰背景图 -->
    <img
      class="bg-layer clear-bg"
      src="../../../assets/annualReport/page5_blackboard_bac.png"
      alt="bg-clear"
    />

    <!-- 2. [中间层] 模糊背景图 -->
    <img
      class="bg-layer blur-bg"
      :class="{ active: isVisible }"
      src="../../../assets/annualReport/page5_blur.png"
      alt="bg-blur"
    />

    <!-- 3. [顶层] 核心视觉卡片 -->
    <div class="visual-card" :class="{ 'start-anim': isVisible }">
      <!-- 卡片内部背景 -->
      <div class="card-bg-container">
        <img
          class="card-img"
          src="../../../assets/annualReport/page5_blackboard_bac.png"
          alt="card-bg"
        />
      </div>

      <!-- 四张装饰图片 -->
      <img
        src="../../../assets/annualReport/365.png"
        class="deco-img deco-img1"
        alt=""
      />
      <img
        src="../../../assets/annualReport/co_branded.png"
        class="deco-img deco-img2"
        alt=""
      />
      <img
        src="../../../assets/annualReport/new_product.png"
        class="deco-img deco-img3"
        alt=""
      />
      <img
        src="../../../assets/annualReport/tournament.png"
        class="deco-img deco-img4"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Page4Adapted",
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },

  mounted() {
    const vm = this;
    vm.observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];
        if (entry.isIntersecting) {
          // console.log("进入视野");
          vm.isVisible = true;
        } else {
          vm.isVisible = false;
        }
      },
      { threshold: 0.5 }
    );

    if (vm.$refs.pageContainer) {
      vm.observer.observe(vm.$refs.pageContainer);
    }
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
/* =========================================
   1. 容器与背景
   ========================================= */
.page-scroll-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
}

.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  object-fit: cover;
}

.clear-bg {
  z-index: 0;
}
/* 中间层：模糊图 */
.blur-bg {
  z-index: 1;
  opacity: 0; /* 默认不可见 */
  transition: opacity 1.2s ease-in-out;
  will-change: opacity;
  transform: translateZ(0); /* 开启硬件加速 */

  /* 当 isVisible 为 true 时，模糊图淡入覆盖清晰图 */
  &.active {
    opacity: 1;
  }
}

/* =========================================
   2. 视觉卡片 (自适应核心)
   ========================================= */
.visual-card {
  position: relative;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  container-type: size;
  isolation: isolate; /* 创建新的层叠上下文 */

  /* 在手机上，1单位 = 1% 屏幕宽度 */
  --unit: 1vw;
}

.card-bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  /* 关键：防止渲染闪烁或透视问题 */
  transform: translateZ(0);
  backface-visibility: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

/* --- 情况 A: 屏幕太宽 (平板/PC/折叠屏展开) --- */
@media (min-aspect-ratio: 13/25) {
  .visual-card {
    height: 100vh;
    /* 锁定为标准 iPhone 比例 390/844 ≈ 0.462 */
    width: calc(100vh * 390 / 844);
    aspect-ratio: 390 / 844;

    /* 重新计算单位 */
    --unit: 0.462vh;
  }
}

/* --- 情况 B: 屏幕太长 (极少数超长带鱼屏) --- */
@media (max-aspect-ratio: 9/21) {
  .visual-card {
    width: 100vw;
    height: calc(100vw * 844 / 390);
    aspect-ratio: 390 / 844;
    --unit: 1vw;
  }
}

/* =========================================
   3. 图片定位与慢速淡入动画
   ========================================= */
.deco-img {
  position: absolute;
  opacity: 0; // 初始隐藏
  // 可以在这里加个简单的缩放过渡，让它除了淡入还有点微小的放大效果（可选）
  transform: scale(0.95);
}

.deco-img1 {
  top: 16.5%;
  left: 36%;
  width: 53%;
}
.deco-img2 {
  top: 34.5%;
  left: 36%;
  width: 24%;
}
.deco-img3 {
  top: 31.5%;
  left: 63%;
  width: 33%;
}
.deco-img4 {
  top: 50.2%;
  left: 37%;
  width: 36%;
}

/* --- 核心修改：调整动画时长和延迟 --- */
.visual-card.start-anim {
  // 第一张图
  .deco-img1 {
    // 2.5s 是动画持续时间 (变慢了)
    animation: fadeInSlow 1s ease-out forwards;
    // 0.5s 开始执行
    animation-delay: 0.5s;
  }

  // 第二张图
  .deco-img2 {
    animation: fadeInSlow 1s ease-out forwards;
    // 1.5s 开始 (比上一张晚 1秒)
    animation-delay: 1s;
  }

  // 第三张图
  .deco-img3 {
    animation: fadeInSlow 1s ease-out forwards;
    // 2.5s 开始 (比上一张晚 1秒)
    animation-delay: 1.5s;
  }

  // 第四张图
  .deco-img4 {
    animation: fadeInSlow 1s ease-out forwards;
    // 3.5s 开始 (比上一张晚 1秒)
    animation-delay: 2s;
  }
}

/* 定义一个新的慢速淡入动画 */
@keyframes fadeInSlow {
  from {
    opacity: 0;
    transform: scale(0.95); // 配合上面的scale，让它稍微从小一点点变大
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
